module.exports = __webpack_public_path__ + "assets/highcharts.0de95cbc.svg";